export function IconSearch() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fill="currentColor" fillRule="evenodd" d="M7.867 5.226a2.641 2.641 0 1 1-5.282 0 2.641 2.641 0 0 1 5.282 0zm-.494 3.641a4.226 4.226 0 1 1 1.494-1.494l1.823 1.823a1.057 1.057 0 0 1-1.494 1.495L7.373 8.867z"/>
        </svg>
    );
}
